import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

 const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
    
  );



  return (
    <section id="About"
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
             <h1 className="mt-16 mb-64 center-content reveal-from-bottom" data-reveal-delay="200">
             <span className="text-color-primary">About us</span>
            </h1>
                  
                  
                  <div className='m-12 mt-12 mb-12 reveal-from-bottom center-content'>
                      <p>
                   We are a passionate and dedicated team behind the DOGECOIN v2 project.
                      </p>

                      <p>
                     Our mission is to create a safe, secure, and innovative cryptocurrency ecosystem that brings value and utility to our community.
                       </p>
                     

                  </div>



            <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 01"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Safety First:
                    </h4>
                  <p className="m-0 text-sm">
                We understand the importance of security in the crypto space. That's why we have implemented robust security measures and rigorous auditing processes to ensure the safety of our platform and our users' funds. We prioritize the protection of our community members and continuously work towards enhancing the security infrastructure of DOGECOIN v2.
                 </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                  Transparency and Trust:
                    </h4>
                  <p className="m-0 text-sm">
                   Transparency is at the core of our operations. We believe in fostering trust and building long-lasting relationships with our community. We provide regular updates, engage in open communication, and actively seek feedback to ensure that our decisions align with the best interests of our users. Trust is earned, and we strive to earn it every step of the way.
                      </p>
                </div>
              </div>
            </div>

               <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                Community-Driven:
                    </h4>
                  <p className="m-0 text-sm">
                  We actively involve our community in decision-making processes through decentralized governance. By empowering our token holders, we create a democratic ecosystem where everyone has a voice. We value the ideas, perspectives, and contributions of our community members and actively seek their input to shape the future of DOGECOIN v2.
                  </p>
                </div>
              </div>
            </div>


                <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                 Innovation and Utility:
                    </h4>
                  <p className="m-0 text-sm">
                  We are committed to driving innovation and providing real-world utility for DOGECOIN v2. We continuously explore new use cases, partnerships, and integrations to enhance the versatility and usefulness of our token. Our goal is to make DOGECOIN v2 a widely accepted and valuable asset, enabling seamless transactions, investments, and engagement within the decentralized finance space.
                       </p>
                </div>
              </div>
            </div>


                <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                  Education and Support:
                    </h4>
                  <p className="m-0 text-sm">
                  We understand that the crypto world can be complex, and we are dedicated to providing educational resources and support to our community. We strive to empower our users with the knowledge and tools necessary to navigate the crypto landscape confidently. Whether you're new to cryptocurrencies or an experienced trader, we are here to assist you every step of the way.
                      </p>
                </div>
              </div>
            </div>


                <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                 DOGECOIN v2 Community:
                    </h4>
                  <p className="m-0 text-sm">
                   We invite you to join the DOGECOIN v2 community and be part of an exciting journey towards a decentralized and inclusive future. Together, we can achieve remarkable milestones, create lasting impact, and revolutionize the way people perceive and engage with cryptocurrencies.
                       </p>
                </div>
              </div>
            </div>
                
                
                <div className='m-12 mt-12 mb-12 reveal-from-bottom center-content'>
    
                       <p >
                 Please note: DOGECOIN v2 is an independent project inspired by DOGE but is not affiliated with or endorsed by the original DOGE development team. We encourage all community members to conduct their own research and make informed decisions when participating in the cryptocurrency market.  </p>
         
              </div>


        

          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;